(() => {
  if (window.__MF_TASSEN_PERLMUTT_MODE__) return;
  window.__MF_TASSEN_PERLMUTT_MODE__ = true;
  const COLORS = [
    { id:'lila', name:'Lila Glow', variant:'51825422238043', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/perlmutt-lila-glow-mockup.png?v=1787756266' },
    { id:'gruen', name:'Grün Glow', variant:'51825422238043', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/perlmutt-gruen-glow-mockup.png?v=1787756279' },
    { id:'blau', name:'Blau Glow', variant:'51825422238043', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/perlmutt-blau-glow-mockup.png?v=1787756295' }
  ];
  const getColor = id => COLORS.find(c => c.id === id) || COLORS[0];
  const activeHost = () => document.querySelector('.mf-designer-dialog[open] [data-mf-tassen-designer-host][data-mf-mug-mode="perlmutt"]') || document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="perlmutt"]');
  const syncVariant = (host, selected) => {
    const shell = host?.closest?.('[data-mf-tassen-designer-shell]');
    if (shell) shell.dataset.mfVariantId = selected.variant;
    if (host) host.dataset.mfPerlmuttVariantId = selected.variant;
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
      if (String(input.value) === selected.variant) return;
      input.value = selected.variant;
      input.dispatchEvent(new Event('input', { bubbles:true }));
      input.dispatchEvent(new Event('change', { bubbles:true }));
    });
  };
  const patchCopy = host => {
    const root = host?.shadowRoot;
    if (!root) return;
    const intro = root.querySelector('.intro h1');
    if (intro && /weiße tasse/i.test(intro.textContent || '')) intro.innerHTML = 'Deine Perlmutt-Tasse.<br><em>Rundum gestaltet.</em>';
    const tip = root.querySelector('.tip-box');
    if (tip) {
      const spans = tip.querySelectorAll('span');
      if (spans[0] && spans[0].textContent !== '1. Perlmuttfarbe auswählen') spans[0].textContent = '1. Perlmuttfarbe auswählen';
      if (spans[1] && spans[1].textContent !== '2. Foto und Text einfügen & ausrichten') spans[1].textContent = '2. Foto und Text einfügen & ausrichten';
      if (spans[2] && spans[2].textContent !== '3. Tasse drehen & Vorschau prüfen') spans[2].textContent = '3. Tasse drehen & Vorschau prüfen';
    }
  };
  const applyColor = (host, id, notify = true) => {
    if (!host) return;
    const selected = getColor(id);
    host.dataset.mfMugMode = 'perlmutt';
    host.dataset.mfPerlmuttColorId = selected.id;
    host.dataset.mfPerlmuttColor = selected.name;
    host.dataset.mfPerlmuttVariantId = selected.variant;
    try { localStorage.setItem('mf-perlmuttfarbe-330ml', selected.id); } catch (_) {}
    syncVariant(host, selected);
    const root = host.shadowRoot;
    root?.querySelectorAll('[data-mf-perlmutt-color]').forEach(button => {
      const on = button.dataset.mfPerlmuttColor === selected.id;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const label = root?.querySelector('[data-mf-perlmutt-color-label]');
    if (label && label.textContent !== selected.name) label.textContent = selected.name;
    const summary = root?.querySelector('.summary-box strong');
    if (summary && summary.textContent !== `Perlmutt-Tasse · ${selected.name}`) summary.textContent = `Perlmutt-Tasse · ${selected.name}`;
    root?.querySelectorAll('.cart-line strong').forEach(el => { if (el.textContent !== `Perlmutt-Tasse · ${selected.name}`) el.textContent = `Perlmutt-Tasse · ${selected.name}`; });
    if (notify) {
      document.dispatchEvent(new CustomEvent('mf:perlmutt-selected', { detail:selected }));
      host.dispatchEvent(new CustomEvent('mf:perlmutt-color-change', { detail:selected }));
    }
  };
  const ensureUI = host => {
    const root = host?.shadowRoot;
    if (!root) return false;
    const controls = root.querySelector('.controls-card');
    if (!controls) return false;
    patchCopy(host);
    if (!root.querySelector('[data-mf-perlmutt-section]')) {
      const section = document.createElement('div');
      section.className = 'control-section mf-perlmutt-section';
      section.dataset.mfPerlmuttSection = '1';
      section.innerHTML = `<div class="control-label"><span>1</span><strong>Perlmuttfarbe</strong></div><div class="mf-perlmutt-head"><small>3 Neon-Glow-Farben</small><b data-mf-perlmutt-color-label></b></div><div class="mf-perlmutt-grid" role="group" aria-label="Perlmuttfarbe wählen">${COLORS.map(c => `<button type="button" data-mf-perlmutt-color="${c.id}" aria-pressed="false" title="${c.name}"><span class="mf-perlmutt-photo"><img src="${c.image}" alt="${c.name}" loading="lazy"></span><span>${c.name}</span></button>`).join('')}</div>`;
      const firstSection = controls.querySelector('.control-section');
      if (firstSection) controls.insertBefore(section, firstSection); else controls.appendChild(section);
      section.querySelectorAll('[data-mf-perlmutt-color]').forEach(button => button.addEventListener('click', () => applyColor(host, button.dataset.mfPerlmuttColor)));
      const sections = [...controls.querySelectorAll('.control-section')].filter(el => !el.matches('[data-mf-perlmutt-section]'));
      sections.forEach((el, index) => { const number = el.querySelector('.control-label > span'); if (number && index < 2) number.textContent = String(index + 2); });
    }
    if (!root.querySelector('#mf-perlmutt-style')) {
      const style = document.createElement('style');
      style.id = 'mf-perlmutt-style';
      style.textContent = `.mf-perlmutt-section{border-top:0!important;padding-top:0!important}.mf-perlmutt-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:-2px 0 10px;color:#aaa}.mf-perlmutt-head small{font-size:11px}.mf-perlmutt-head b{color:#f58220;font-size:12px}.mf-perlmutt-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}.mf-perlmutt-grid button{min-width:0;display:grid;grid-template-rows:62px auto;gap:5px;align-items:center;padding:6px;border:1px solid rgba(255,255,255,.16);border-radius:8px;background:#232426;color:#eee;cursor:pointer}.mf-perlmutt-grid button:hover{border-color:rgba(245,130,32,.65)}.mf-perlmutt-grid button.is-active{border-color:#f58220;box-shadow:0 0 0 1px #f58220;background:rgba(245,130,32,.10)}.mf-perlmutt-photo{display:flex;width:100%;height:62px;align-items:center;justify-content:center;border-radius:6px;overflow:hidden;background:#fff}.mf-perlmutt-photo img{display:block;width:100%;height:100%;object-fit:contain}.mf-perlmutt-grid button>span:last-child{font-size:9px;font-weight:800;line-height:1.15;text-align:center;white-space:normal}@media(max-width:749px){.mf-perlmutt-grid{gap:6px}.mf-perlmutt-grid button{grid-template-rows:50px auto;padding:5px}.mf-perlmutt-photo{height:50px}.mf-perlmutt-grid button>span:last-child{font-size:8px}}`;
      root.appendChild(style);
    }
    let selectedId = host.dataset.mfPerlmuttColorId || '';
    if (!selectedId) { try { selectedId = localStorage.getItem('mf-perlmuttfarbe-330ml') || ''; } catch (_) {} }
    applyColor(host, selectedId || 'lila', false);
    return true;
  };
  const watchHost = host => {
    if (!host || host.dataset.mfPerlmuttWatch === '1') return;
    host.dataset.mfMugMode = 'perlmutt';
    host.dataset.mfPerlmuttWatch = '1';
    let tries = 0;
    const tick = () => {
      tries += 1;
      const ready = ensureUI(host);
      if (ready && host.shadowRoot && !host.__mfPerlmuttShadowObserver) {
        const observer = new MutationObserver(() => ensureUI(host));
        observer.observe(host.shadowRoot, { childList:true, subtree:true });
        host.__mfPerlmuttShadowObserver = observer;
      }
      if (!ready && tries < 100) setTimeout(tick, 100);
    };
    tick();
  };
  const boot = () => document.querySelectorAll('[data-mf-tassen-designer-host][data-mf-mug-mode="perlmutt"]').forEach(watchHost);
  window.__MF_TASSEN_PERLMUTT_BOOT__ = boot;
  document.addEventListener('mf:perlmutt-select', event => {
    const host = activeHost() || document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="perlmutt"]');
    if (!host) return;
    applyColor(host, event.detail?.id || 'lila', false);
    ensureUI(host);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
  if (!window.__MF_PERLMUTT_FETCH_PATCH__) {
    window.__MF_PERLMUTT_FETCH_PATCH__ = true;
    const previousFetch = window.fetch.bind(window);
    window.fetch = async function mfPerlmuttFetch(input, init = {}) {
      try {
        const url = typeof input === 'string' ? input : String(input?.url || '');
        const method = String(init?.method || 'GET').toUpperCase();
        const body = init?.body;
        if (method === 'POST' && /\/cart\/add\.js(?:\?|$)/.test(url) && body instanceof FormData) {
          const host = activeHost();
          if (host?.dataset?.mfMugMode === 'perlmutt') {
            const selected = getColor(host.dataset.mfPerlmuttColorId || 'lila');
            body.set('id', selected.variant);
            if (!body.has('properties[Perlmutt-Farbe]')) body.append('properties[Perlmutt-Farbe]', selected.name);
            if (!body.has('properties[_MF Perlmuttfarbe-ID]')) body.append('properties[_MF Perlmuttfarbe-ID]', selected.id);
          }
        }
      } catch (error) { console.warn('[MF Perlmutt]', error); }
      return previousFetch(input, init);
    };
  }
})();